// plugins/permissionChecker.ts
import { useRolePermission } from "~/composables/useRolePermission";

export default defineNuxtPlugin((nuxtApp) => {
  const { computePermissions } = useRolePermission();

  nuxtApp.provide(
    "hasPermission",
    (permission: string, environment: string): boolean => {
      if (!environment) {
        return false;
      }

      const normalizedPermission = `${permission
        .trim()
        .toLowerCase()}: ${environment.trim().toLowerCase()}`;

      return computePermissions([normalizedPermission]);
    }
  );
});
